import { selectUser } from '@propertypal/shared/src/reducers/user';
import NotesIcon from '@propertypal/shared/src/resources/icons/property/notes-icon.svg';
import ShareIcon from '@propertypal/shared/src/resources/icons/property/share-icon.svg';
import { Property } from '@propertypal/shared/src/types/property';
import Accordion from '@propertypal/web-ui/src/animation/Accordion';
import PropertyFavourite from '@propertypal/web-ui/src/property/PropertyFavourite';
import router from 'next/router';
import React, { FunctionComponent, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTheme } from 'styled-components';
import NoteItems from '../my/notes/NoteItems';
import { Container, Content, Item, ItemRow, NotesWrapper } from './PropertySocialBar.style';

interface Props {
  property: Property;
  favourited: boolean;
  onFavourite: (favourited: boolean) => Promise<boolean>;
  onShare: () => void;
}

const PropertySocialBar: FunctionComponent<Props> = (props) => {
  const user = useSelector(selectUser);
  const theme = useTheme();
  const [notesOpen, setNotesOpen] = useState(user.loggedIn);
  const propertyFavourite = useRef<HTMLButtonElement>(null);

  const toggleNotes = () => {
    if (notesOpen) {
      setNotesOpen(false);
    } else if (!user.loggedIn) {
      router.push(`/login?sourcePath=${window.location.pathname}`);
    } else {
      setNotesOpen(true);
    }
  };

  return (
    <Container className="pp-social-bar hide-print">
      <Content>
        <ItemRow>
          <Item as="div">
            <PropertyFavourite
              key="socialBarFavourite"
              innerRef={propertyFavourite}
              favourited={props.favourited}
              onFavourite={props.onFavourite}
              dark
              containerStyle={{ marginLeft: -5, marginRight: -5 }}
            />

            {/* without function curry, click event will throw illegal invocation error */}
            <button onClick={() => propertyFavourite.current?.click()} className="buttonText" type="button">
              Favourite This Property
            </button>
          </Item>

          {props.property.published && (
            <>
              <Item data-testid="sharePropertyButton" onClick={props.onShare} type="button">
                <ShareIcon color={theme.textDark} className="pp-social-icon" />
                <p>Share This Property</p>
              </Item>

              <Item data-testid="addPersonalNoteButton" onClick={toggleNotes} type="button">
                <NotesIcon color={theme.textDark} className="pp-social-icon" />
                <p>Add A Personal Note</p>
              </Item>
            </>
          )}
        </ItemRow>

        {user.loggedIn && props.property.published && (
          <Accordion isOpen={notesOpen}>
            <NotesWrapper data-testid="notesWrapper">
              <NoteItems property={props.property} notes={props.property.notes} />
            </NotesWrapper>
          </Accordion>
        )}
      </Content>
    </Container>
  );
};

export default PropertySocialBar;
